export default __webpack_public_path__ + "static/media/coffee.0f15e243.png";